import React from "react";

const StepNavigation = ({ currentStep }) => {
  const steps = [
    { label: "Email", key: 1 },
    { label: "Mobile", key: 2 },
    { label: "Reset", key: 3 },
  ];

  return (
    <div className="flex items-center mt-2 justify-center space-x-8 relative">
      {steps.map((step, index) => (
        <div
          key={index}
          className="relative flex flex-col items-center justify-center"
        >
          {/* Image Icon on top of the circle */}
          {currentStep == step.key && (
            <img
              src="/down-grey-steps.svg"
              alt="Step Icon"
              className="h-3 w-3"
            />
          )}
             {currentStep != step.key && (
            <div className="h-3 w-3"></div>
          )}

          {/* Circle */}
          <div
            className={`w-12 h-12 z-50  flex items-center justify-center rounded-full text-sm ${
              currentStep === step.key || currentStep > step.key
                ? "bg-black text-white"
                : "bg-white text-[#C8C8C8] border border-[#C8C8C8]"
            }`}
          >
            {currentStep > step.key && (
              <img
                src="/white-tick.svg" // Tick icon inside completed steps
                alt="Step Completed"
                className="h-4 w-4"
              />
            )}
            {currentStep === step.key && (
              <span
                className={`${
                  currentStep === step.key ? "text-white" : "text-[#C8C8C8]"
                }`}
              >
                {step.key}
              </span>
            )}
            {currentStep < step.key && (
              <span className="text-[#C8C8C8]">{step.key}</span>
            )}
          </div>

          {index != 0 && index < steps.length && (
            <div className="absolute right-10 top-1/2 transform -translate-y-1/2 w-20 h-px bg-[#C8C8C8]"></div>
          )}

          <div className="mt-2 text-center text-[#C8C8C8] text-xs">
            {step.label}
          </div>
        </div>
      ))}
    </div>
  );
};

export default StepNavigation;
